
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drought",
      function () {
        return require("private-next-pages/drought.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drought"])
      });
    }
  